import { StandardTextFieldProps } from '@material-ui/core/TextField/TextField';
import React, { ChangeEvent } from 'react';
import { ITender } from 'src/common/interfaces/dtos/ITender';
import { ITenderExchange } from 'src/common/interfaces/dtos/ITenderExchange';
import { ITenderExchangeDetails } from 'src/common/interfaces/states/ITenderExchangeState';
import { cancelPinpadOperation } from 'src/devices/payment/pinpad-operations';
import TenderExchange from './tender-exchange';
import TenderOptions from './tender-options';

const TenderExchangeWindow = (props: ITenderExchangeWindowProps): JSX.Element | null => {
  if (props.paymentTender && !props.showRefundScreens) {
    props.setDisplayInputField(false);
    if (!props.paymentTender.isProcessedByEps || props.paymentTender.type === 'Voucher') {
      cancelPinpadOperation();
    }
    return <TenderOptions {...props} />;
  } else {
    props.setDisplayInputField(true);
    return <TenderExchange {...props} />;
  }
};

export default TenderExchangeWindow;

export interface ITenderExchangeWindowProps {
  onCancel: () => void;
  tenderExchange: ITenderExchange;
  onBack: () => void;
  paymentTender?: ITender;
  refundTender?: ITender;
  updateTenderExchangeDetails: (details: ITenderExchangeDetails) => void;
  showRefundScreens?: boolean;
  onTextChange: (event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  amountInputElement: StandardTextFieldProps;
  setDisplayInputField: (type: boolean) => void;
  onSubmit: (amount?: number) => Promise<void>;
  onKeypadSubmit: (value: string) => Promise<void>;
  onVoucherPayment: (barcode: string) => Promise<void>;
  inputRef: React.RefObject<HTMLInputElement>;
}
